import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    height: 18px;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    margin: 12px 8px;\n    ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    resize: none;\n    ", ";\n    border: none;\n    outline: none;\n    padding: 8px 8px 10px;\n\n    ", ";\n    ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    border: none;\n    outline: none;\n    min-width: 30px;\n\n    ", ";\n    ", ";\n    ", ";\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n        appearance: none;\n    }\n\n    &::-ms-clear {\n        display: none;\n    }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 4px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    flex-grow: 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: stretch;\n    box-sizing: border-box;\n    flex-direction: ", ";\n\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        &,\n        &:active,\n        &:focus,\n        &:hover {\n            color: ", ";\n        }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n              &,\n              &:hover,\n              &:focus,\n              &:active {\n                  border-color: ", ";\n                  color: ", ";\n              }\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n              border-color: ", ";\n              color: ", ";\n          "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n              &,\n              &:hover,\n              &:focus,\n              &:active {\n                  border-color: ", ";\n                  color: ", ";\n              }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        padding: 0 ", "px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n\n        &::placeholder {\n            color: ", ";\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        border-radius: ", ";\n        width: ", ";\n        height: ", "px;\n        color: ", ";\n        background-color: ", ";\n\n        &:hover {\n            border-color: ", ";\n            color: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Row } from '../Row';
import { Button } from '../Button';
import { CrossIcon } from '../icons';
import { typography } from '../mixins';
import { noop } from '../helpers';
var ClearIconSizes = {
  small: 12,
  medium: 16,
  large: 18
};

function themedStylesTextField(props) {
  var _props$theme = props.theme,
      palette = _props$theme.palette,
      shape = _props$theme.shape,
      inputSize = props.inputSize,
      width = props.width,
      fullWidth = props.fullWidth,
      multiline = props.multiline,
      error = props.error;

  var _ref = error ? palette.error : palette.primary,
      main = _ref.main,
      hoverColor = _ref.hover;

  var mainColor = error ? main : palette.gray.gray300;
  return css(_templateObject(), mainColor, inputSize === 'medium' ? shape.borderRadius.large : shape.borderRadius.medium, fullWidth ? '100%' : width ? "".concat(width, "px") : 'auto', multiline ? 'auto' : inputSize === 'medium' ? 44 : 30, palette.gray.gray300, palette.common.white, hoverColor, hoverColor);
}

function themedStylesInput(props) {
  var palette = props.theme.palette,
      disabled = props.disabled;
  return css(_templateObject2(), disabled ? palette.gray.gray200 : palette.text.primary, palette.gray.gray300);
}

function padding(_ref2) {
  var inputSize = _ref2.inputSize;
  return css(_templateObject3(), inputSize === 'medium' ? 8 : 4);
}

function disabled(props) {
  var gray = props.theme.palette.gray,
      disabled = props.disabled;
  return disabled ? css(_templateObject4(), gray.gray200, gray.gray200) : null;
}

function focused(props) {
  var palette = props.theme.palette,
      focused = props.focused,
      error = props.error;

  var _ref3 = error ? palette.error : palette.primary,
      active = _ref3.active;

  return focused ? css(_templateObject5(), active, active) : null;
}

function readOnly(props) {
  var palette = props.theme.palette,
      readOnly = props.readOnly,
      error = props.error;
  var color = palette.gray.gray300;
  return readOnly && !error ? css(_templateObject6(), color, color) : null;
}

function setColor(color) {
  return css(_templateObject7(), color);
}

function autoResize(node) {
  if (!node) {
    return;
  }

  var _window$getComputedSt = window.getComputedStyle(node),
      borderBottomWidth = _window$getComputedSt.borderBottomWidth,
      borderTopWidth = _window$getComputedSt.borderTopWidth;

  var placeholder = node.placeholder;
  node.placeholder = '';
  node.style.height = 'auto';
  node.style.height = "".concat(node.scrollHeight + parseInt(borderBottomWidth) + parseInt(borderTopWidth), "px");
  node.placeholder = placeholder;
}

function setMaxHeight(node, maxRows) {
  if (!node) {
    return;
  }

  var maxHeight = '';

  if (maxRows) {
    var _window$getComputedSt2 = window.getComputedStyle(node),
        lineHeight = _window$getComputedSt2.lineHeight,
        paddingTop = _window$getComputedSt2.paddingTop,
        paddingBottom = _window$getComputedSt2.paddingBottom;

    maxHeight = "calc(".concat(maxRows, " * ").concat(lineHeight, " + ").concat(paddingTop, " + ").concat(paddingBottom, ")");
  }

  node.style.maxHeight = maxHeight;
}

var StyledTextField = styled.div(_templateObject8(), function (_ref4) {
  var multiline = _ref4.multiline;
  return multiline ? 'column' : 'row';
}, typography('body2'), padding, themedStylesTextField, focused, disabled, readOnly);
var Slot = styled.div(_templateObject9());
var CrossButton = styled(Button)(_templateObject10());
var StyledInput = styled.input(_templateObject11(), typography('body2'), padding, themedStylesInput);
var StyledTextarea = styled.textarea(_templateObject12(), typography('body1'), function (_ref5) {
  var theme = _ref5.theme;
  return setColor(theme.palette.common.black);
}, disabled);
var TextareaBottom = styled(Row.Container)(_templateObject13(), function (_ref6) {
  var theme = _ref6.theme;
  return setColor(theme.palette.gray.gray400);
});
var CounterWrapper = styled(Row.Item)(_templateObject14());
export var TextField = React.forwardRef(function (_a, ref) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'small' : _a$size,
      prefix = _a.prefix,
      startAdornment = _a.startAdornment,
      postfix = _a.postfix,
      endAdornment = _a.endAdornment,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$readOnly = _a.readOnly,
      readOnly = _a$readOnly === void 0 ? false : _a$readOnly,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$clear = _a.clear,
      clear = _a$clear === void 0 ? false : _a$clear,
      width = _a.width,
      value = _a.value,
      _a$inputRef = _a.inputRef,
      inputRef = _a$inputRef === void 0 ? useRef(null) : _a$inputRef,
      className = _a.className,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'text' : _a$type,
      _a$error = _a.error,
      error = _a$error === void 0 ? false : _a$error,
      _a$multiline = _a.multiline,
      multiline = _a$multiline === void 0 ? false : _a$multiline,
      _a$rows = _a.rows,
      rows = _a$rows === void 0 ? 2 : _a$rows,
      _a$maxRows = _a.maxRows,
      maxRows = _a$maxRows === void 0 ? 4 : _a$maxRows,
      maxLength = _a.maxLength,
      _a$onFocus = _a.onFocus,
      onFocus = _a$onFocus === void 0 ? noop : _a$onFocus,
      _a$onBlur = _a.onBlur,
      onBlur = _a$onBlur === void 0 ? noop : _a$onBlur,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      _a$onClick = _a.onClick,
      onClick = _a$onClick === void 0 ? noop : _a$onClick,
      _a$onClear = _a.onClear,
      onClear = _a$onClear === void 0 ? noop : _a$onClear,
      props = __rest(_a, ["size", "prefix", "startAdornment", "postfix", "endAdornment", "disabled", "readOnly", "fullWidth", "clear", "width", "value", "inputRef", "className", "type", "error", "multiline", "rows", "maxRows", "maxLength", "onFocus", "onBlur", "onChange", "onClick", "onClear"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState((value === null || value === void 0 ? void 0 : value.length) || 0),
      _useState4 = _slicedToArray(_useState3, 2),
      textLength = _useState4[0],
      setTextLength = _useState4[1];

  var handleFocus = useCallback(function (event) {
    setFocused(true);
    onFocus(event);
  }, [setFocused, onFocus]);
  var handleBlur = useCallback(function (event) {
    setFocused(false);
    onBlur(event);
  }, [setFocused, onBlur]);
  var handleClickClear = useCallback(function (event) {
    if (onChange) {
      onChange({
        target: {
          value: ''
        }
      });
    }

    if (onClear) {
      onClear(event);
    }
  }, [onChange, onClear]);
  var handleChange = useCallback(function (event) {
    if (multiline) {
      if (maxLength) {
        setTextLength(event.target.value.length);
      }

      autoResize(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    }

    onChange(event);
  }, [onChange, inputRef, multiline, maxLength]);
  useEffect(function () {
    var node = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
    autoResize(node);
    setMaxHeight(node, maxRows);
  }, [maxRows, inputRef]);
  useEffect(function () {
    setTextLength((value === null || value === void 0 ? void 0 : value.length) || 0);
  }, [value]);
  var renderField = multiline ? React.createElement(React.Fragment, null, React.createElement(StyledTextarea, Object.assign({}, props, {
    ref: inputRef,
    value: value,
    rows: rows,
    maxLength: maxLength,
    disabled: disabled,
    readOnly: readOnly,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange
  })), (startAdornment || prefix || maxLength) && React.createElement(TextareaBottom, {
    gap: 20,
    alignItems: 'center',
    align: 'spaced'
  }, React.createElement(Row.Item, null, startAdornment || prefix), maxLength && React.createElement(CounterWrapper, null, isFocused ? maxLength - textLength : ''))) : React.createElement(React.Fragment, null, (startAdornment || prefix) && React.createElement(Slot, null, startAdornment || prefix), React.createElement(StyledInput, Object.assign({}, props, {
    ref: inputRef,
    value: value,
    inputSize: size,
    type: type,
    disabled: disabled,
    readOnly: readOnly,
    maxLength: maxLength,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange
  })), clear && value && React.createElement(Slot, null, React.createElement(CrossButton, {
    onClick: handleClickClear,
    variant: 'text'
  }, React.createElement(CrossIcon, {
    width: ClearIconSizes[size]
  }))), (endAdornment || postfix) && React.createElement(Slot, null, endAdornment || postfix));
  return React.createElement(StyledTextField, {
    ref: ref,
    inputSize: size,
    width: width,
    fullWidth: fullWidth,
    multiline: multiline,
    focused: isFocused,
    error: error,
    disabled: disabled,
    readOnly: readOnly,
    className: className,
    onClick: onClick
  }, renderField);
});
TextField.displayName = 'TextField';